import { createAction, props } from '@ngrx/store';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { SelectItem } from 'primeng/api';
import { CommonPersonModel } from 'src/app/model/common/person';
import { CommonPersonViewModel } from 'src/app/model/common/person.view';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';

enum CommonPersonLabels {
  SET_RESULT = 'COMMON_PERSON_SET_RESULT',
  ADD_RESULT = 'COMMON_PERSON_ADD_RESULT',
  PATCH_RESULT = 'COMMON_PERSON_PATCH_RESULT',
  SET_PERSON = 'COMMON_PERSON_SET_PERSON',
  SET_LOCATION_BORN = 'COMMON_PERSON_SET_LOCATION_BORN',
  SET_PERSON_DEFAULT = 'COMMON_PERSON_SET_PERSON_DEFAULT',
  SET_ALL_DEFAULT = 'COMMON_PERSON_SET_ALL_DEFAULT',
}

export const commonPersonActions = {
  setResultAction: createAction(
    CommonPersonLabels.SET_RESULT,
    props<VonPageResponseModel<CommonPersonViewModel>>()
  ),
  addResultAction: createAction(
    CommonPersonLabels.ADD_RESULT,
    props<CommonPersonViewModel>()
  ),
  patchResultAction: createAction(
    CommonPersonLabels.PATCH_RESULT,
    props<CommonPersonViewModel>()
  ),
  setPersonAction: createAction(
    CommonPersonLabels.SET_PERSON,
    props<CommonPersonModel>()
  ),
  setLocationBornAction: createAction(
    CommonPersonLabels.SET_LOCATION_BORN,
    props<SelectItem<KhuyanaSelectItemModel>>()
  ),
  setPersonDefaultAction: createAction(
    CommonPersonLabels.SET_PERSON_DEFAULT,
    props<any>()
  ),
  setAllDefaultAction: createAction(
    CommonPersonLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
};
